import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUnlockAlt } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import {
  tenDigitRegexStartingWith9,
  EMAIL_REGEX,
} from "../../helpers/regexHelper";
import toast from "react-hot-toast";
import {
  Form,
  Card,
  Col,
  InputGroup,
  Button,
  Row,
  Spinner,
} from "@themesberg/react-bootstrap";
import {
  clearIndividualCollector,
  createCollector,
  getCollectorById,
  getCollectors,
  transferCollectorCustomers,
  updateCollector,
} from "../../redux/actions/collector";
import CustomErrorView from "../../components/CustomErrorView";
import CustomDashboardLoader from "../../components/CustomDashboardLoader";
import CollectorHelper from "../../helpers/CollectorHelper";

const initialErrors = {
  errorName: "",
  errorEmail: "",
  errorUsername: "",
  errorPassword: "",
  errorPhone: "",
};
const initialValues = {
  oldCollectorId: "",
  name: "",
  email: "",
  username: "",
  password: "",
  phone: "",
};

function EditCollector({ match }) {
  const dispatch = useDispatch();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showErrPage, setShowErrPage] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [values, setValues] = useState(initialValues);
  const [errors, setErrors] = useState(initialErrors);
  const [isActive, setIsActive] = useState(true);
  const [collectorVal, setCollectorVal] = useState(null);
  const [isCollectorLoading, setIsCollectorLoading] = useState(false);
  const [changedCollectorData, setChangedCollectorData] = useState([]);
  const collectorData = useSelector((state) => state.collector.collectorData);

  const { name, email, username, password, phone, oldCollectorId } = values;
  const { errorName, errorEmail, errorUsername, errorPassword, errorPhone } =
    errors;

  const loadSuccess = (responseData) => {
    const initialFilledObject = {
      name: responseData.name,
      email: responseData.email,
      username: responseData.username,
      password: "",
      phone: responseData.mobileNumber,
      oldCollectorId: responseData.id,
    };
    setValues(initialFilledObject);
    setIsActive(responseData.isActive);
    setIsLoading(false);
  };
  const loadFailure = () => {
    setIsLoading(false);
    setShowErrPage(true);
  };

  useEffect(() => {
    const someId = match.params?.id;
    if (!someId) {
      setShowErrPage(true);
    } else {
      setIsLoading(true);
      dispatch(getCollectorById(someId, loadSuccess, loadFailure));
      dispatch(getCollectors()).then(() => setIsCollectorLoading(false));
    }
    return () => {
      dispatch(clearIndividualCollector());
    };
  }, []);
  useEffect(() => {
    const tempArr = CollectorHelper(collectorData);
    setChangedCollectorData(tempArr);
  }, [collectorData]);

  const transferHandler = () => {
    if (collectorVal === null) {
      toast.error("Please select a collector first");
    } else if (collectorVal === "") {
      toast.error("Please select a collector first");
    } else {
      setIsSubmitting(true);

      dispatch(transferCollectorCustomers(oldCollectorId, collectorVal)).then(
        () => setIsSubmitting(false)
      );
    }
  };

  const passwordChangeHandler = (e) => {
    e.preventDefault();
    let hasErrors = false;
    if (!/\S/.test(password)) {
      hasErrors = true;
      errorHandler("errorPassword", "Password cannot be empty");
    } else if (password.length < 6) {
      hasErrors = true;
      errorHandler(
        "errorPassword",
        "Password should be minimum of 6 characters long"
      );
    } else {
      errorHandler("errorPassword", "");
    }

    if (hasErrors) {
      toast.error("Please check all the form fields");
    } else {
      setErrors(initialErrors);
      setIsSubmitting(true);
      const data = {
        username,
        password,
      };
      dispatch(updateCollector(data, handleSuccess, handleFaliure));
    }
  };
  const isActiveHandler = () => {
    setIsSubmitting(true);

    const data = {
      username,
      isActive,
    };
    dispatch(updateCollector(data, handleSuccess, handleFaliure));
  };

  const handleSuccess = () => {
    setIsSubmitting(false);
    toast.success("Collector has successfully been updated");
  };
  const handleFaliure = () => {
    setIsSubmitting(false);
  };

  const onChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };
  const errorHandler = (key, val) => {
    setErrors((current) => {
      return { ...current, [key]: val };
    });
  };

  const submitHandler = (e) => {
    e.preventDefault();
    let hasErrors = false;
    if (!/\S/.test(name)) {
      hasErrors = true;
      errorHandler("errorName", "Name cannot be empty");
    } else {
      errorHandler("errorName", "");
    }
    if (!/\S/.test(email)) {
      hasErrors = true;
      errorHandler("errorEmail", "Email cannot be empty");
    } else if (!EMAIL_REGEX.test(email)) {
      hasErrors = true;
      errorHandler("errorEmail", "Enter a valid email");
    } else {
      errorHandler("errorEmail", "");
    }

    if (!/\S/.test(phone)) {
      hasErrors = true;
      errorHandler("errorPhone", "Phone cannot be empty");
    } else if (!tenDigitRegexStartingWith9.test(phone)) {
      hasErrors = true;
      errorHandler(
        "errorPhone",
        "Phone should be of 10 digits starting with 9"
      );
    } else {
      errorHandler("errorPhone", "");
    }

    if (hasErrors) {
      toast.error("Please check all the form fields");
    } else {
      setErrors(initialErrors);
      setIsSubmitting(true);
      const data = {
        name,
        email,
        mobileNumber: phone,
        username,
      };
      dispatch(updateCollector(data, handleSuccess, handleFaliure));
    }
  };

  if (showErrPage) {
    return <CustomErrorView />;
  } else {
    return (
      <div>
        {isLoading ? (
          <CustomDashboardLoader />
        ) : (
          <>
            <Col md={12} className={"mt-3"}>
              <Card border="light" className="bg-white shadow-sm mb-4 p-0">
                <Card.Body>
                  <h5 className="mb-4">Edit Collectors Account</h5>

                  <Form onSubmit={submitHandler}>
                    <Row>
                      <Col md={6} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Name</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder=""
                            name="name"
                            onChange={onChange}
                            value={name}
                            size="sm"
                          />
                          {errorName !== "" && (
                            <Form.Text className="text-danger">
                              {errorName}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={6} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Email address</Form.Label>
                          <Form.Control
                            type="email"
                            placeholder=""
                            name="email"
                            onChange={onChange}
                            value={email}
                            size="sm"
                          />
                          {errorEmail !== "" && (
                            <Form.Text className="text-danger">
                              {errorEmail}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>

                      {/* HERE */}
                      <Col md={6} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Username</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder=""
                            name="username"
                            value={username}
                            disabled={true}
                            size="sm"
                          />
                          {errorUsername !== "" && (
                            <Form.Text className="text-danger">
                              {errorUsername}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>

                      {/* end here */}
                      <Col md={6} className="mb-3">
                        <Form.Group id="phone">
                          <Form.Label>Phone</Form.Label>
                          <Form.Control
                            required
                            type="number"
                            placeholder=""
                            name="phone"
                            onChange={onChange}
                            value={phone}
                            size="sm"
                          />
                          {errorPhone !== "" && (
                            <Form.Text className="text-danger">
                              {errorPhone}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                    </Row>
                    <div className="d-flex justify-content-end">
                      <Button
                        variant="primary"
                        className="m-1"
                        onClick={submitHandler}
                        disabled={isSubmitting}
                      >
                        {isSubmitting === true ? (
                          <Spinner animation="border" />
                        ) : (
                          "Update Collector"
                        )}
                      </Button>
                    </div>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
            <Col md={12} className={"mt-3"}>
              <Card border="light" className="bg-white shadow-sm mb-4 p-0">
                <Card.Body>
                  <h5 className="mb-4">Change Password</h5>

                  <Form onSubmit={passwordChangeHandler}>
                    <Row>
                      <Col md={12} className="mb-3">
                        <Form.Group id="password" className="mb-4">
                          <Form.Label>Password</Form.Label>
                          <InputGroup>
                            <InputGroup.Text>
                              <FontAwesomeIcon icon={faUnlockAlt} />
                            </InputGroup.Text>
                            <Form.Control
                              required
                              name="password"
                              type="password"
                              value={password}
                              // placeholder="Password"
                              onChange={onChange}
                              size="sm"
                            />
                          </InputGroup>
                          {errorPassword !== "" && (
                            <Form.Text className="text-danger">
                              {errorPassword}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                    </Row>
                    <div className="d-flex justify-content-end">
                      <Button
                        variant="primary"
                        className="m-1"
                        onClick={passwordChangeHandler}
                        disabled={isSubmitting}
                      >
                        {isSubmitting === true ? (
                          <Spinner animation="border" />
                        ) : (
                          "Change Password"
                        )}
                      </Button>
                    </div>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
            <Col md={12} className={"mt-3"}>
              <Card border="light" className="bg-white shadow-sm mb-4 p-0">
                <Card.Body>
                  <h5 className="mb-4">Transfer Customers</h5>

                  {isCollectorLoading ? (
                    <Spinner animation="border" />
                  ) : (
                    <Form onSubmit={transferHandler}>
                      <Row>
                        <Col md={12} className="mb-3">
                          <Form.Group className="mb-3">
                            <Form.Label>
                              Transfer all assigned customers to another
                              collector
                            </Form.Label>
                            <Form.Select
                              aria-label="Default select example"
                              value={collectorVal}
                              onChange={(e) => setCollectorVal(e.target.value)}
                              size="sm"
                            >
                              <option value={null}>{null}</option>
                              {changedCollectorData.map((item) => (
                                <option
                                  value={item.customerId}
                                  key={item.customerId}
                                >
                                  {item.name} - ({item.username})
                                </option>
                              ))}
                            </Form.Select>
                          </Form.Group>
                        </Col>
                      </Row>
                      <div className="d-flex justify-content-end">
                        <Button
                          variant="primary"
                          className="m-1"
                          onClick={transferHandler}
                          disabled={isSubmitting}
                        >
                          {isSubmitting === true ? (
                            <Spinner animation="border" />
                          ) : (
                            "Transfer Customers"
                          )}
                        </Button>
                      </div>
                    </Form>
                  )}
                </Card.Body>
              </Card>
            </Col>
            Enable or Disable a collector
            <Col md={12} className={"mt-3"}>
              <Card border="light" className="bg-white shadow-sm mb-4 p-0">
                <Card.Body>
                  <div
                    className="d-flex"
                    style={{
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <h5>
                      {isActive
                        ? "Save to Enable this Collector"
                        : "Save to Disable this Collector"}
                    </h5>
                    <Form>
                      <Form.Check
                        type="switch"
                        id="custom-switch"
                        checked={isActive}
                        onChange={() => setIsActive((curr) => !curr)}
                        size="sm"
                      />
                    </Form>
                  </div>
                  <div className="d-flex justify-content-end mt-4">
                    <Button
                      variant={isActive ? "primary" : "danger"}
                      className="m-1"
                      onClick={isActiveHandler}
                      disabled={isSubmitting}
                    >
                      {isSubmitting === true ? (
                        <Spinner animation="border" />
                      ) : isActive ? (
                        "Save"
                      ) : (
                        "Save"
                      )}
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </>
        )}
      </div>
    );
  }
}

export default EditCollector;
